import { ROLES } from '@/models/Rolle';
import GemeindenView from '@/views/auth/berechnungsgrundlagen/allgemein/gemeinde/IndexView.vue';
import GemeindeEditView from '@/views/auth/berechnungsgrundlagen/allgemein/gemeinde/_id.vue';
import NutzungsartView from '@/views/auth/berechnungsgrundlagen/allgemein/nutzungsart/IndexView.vue';
import NutzungsartEditView from '@/views/auth/berechnungsgrundlagen/allgemein/nutzungsart/_id.vue';
import NutzungsgradWaermeerzeugerHeizungView from '@/views/auth/berechnungsgrundlagen/gebaeude/nutzungsgrad_waermeerzeuger_heizung/IndexView.vue';
import NutzungsgradWaermeerzeugerHeizungEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/nutzungsgrad_waermeerzeuger_heizung/_id.vue';
import NutzungsgradWaermeerzeugerWarmwasserView from '@/views/auth/berechnungsgrundlagen/gebaeude/nutzungsgrad_waermeerzeuger_warmwasser/IndexView.vue';
import NutzungsgradWaermeerzeugerWarmwasserEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/nutzungsgrad_waermeerzeuger_warmwasser/_id.vue';
import ZuordnungEnergieWaermequelleView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_energie_waermequelle/IndexView.vue';
import ZuordnungEnergieWaermequelleEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_energie_waermequelle/_id.vue';
import GebaeudeklasseNutzungsartView from '@/views/auth/berechnungsgrundlagen/gebaeude/gebaeudeklasse_nutzungsart/IndexView.vue';
import GebaeudeklasseNutzungsartEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/gebaeudeklasse_nutzungsart/_id.vue';
import KennzahlNutzungsartView from '@/views/auth/berechnungsgrundlagen/gebaeude/kennzahl_nutzungsart/IndexView.vue';
import KennzahlNutzungsartEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/kennzahl_nutzungsart/_id.vue';
import WaermeerzeugerHeizungView from '@/views/auth/berechnungsgrundlagen/gebaeude/waermeerzeuger_heizung/IndexView.vue';
import WaermeerzeugerHeizungEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/waermeerzeuger_heizung/_id.vue';
import ZuordnungWaermeerzeugerHeizungView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_heizung/IndexView.vue';
import ZuordnungWaermeerzeugerHeizungEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_heizung/_id.vue';
import WaermeerzeugerWarmwasserView from '@/views/auth/berechnungsgrundlagen/gebaeude/waermeerzeuger_warmwasser/IndexView.vue';
import WaermeerzeugerWarmwasserEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/waermeerzeuger_warmwasser/_id.vue';
import ZuordnungWaermeerzeugerWarmwasserView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_warmwasser/IndexView.vue';
import ZuordnungWaermeerzeugerWarmwasserEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_warmwasser/_id.vue';
import KorrekturWaermeerzeugerHeizungView from '@/views/auth/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_heizung/IndexView.vue';
import KorrekturWaermeerzeugerHeizungEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_heizung/_id.vue';
import KorrekturWaermeerzeugerWarmwasserView from '@/views/auth/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_warmwasser/IndexView.vue';
import KorrekturWaermeerzeugerWarmwasserEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_warmwasser/_id.vue';
import AnteilWaermeerzeugerHeizungView from '@/views/auth/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_heizung/IndexView.vue';
import AnteilWaermeerzeugerHeizungEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_heizung/_id.vue';
import AnteilWaermeerzeugerWarmwasserView from '@/views/auth/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_warmwasser/IndexView.vue';
import AnteilWaermeerzeugerWarmwasserEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_warmwasser/_id.vue';
import ReduktionAngrenzendeGebaeudeView from '@/views/auth/berechnungsgrundlagen/gebaeude/reduktion_angrenzende_gebaeude/IndexView.vue';
import ReduktionAngrenzendeGebaeudeEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/reduktion_angrenzende_gebaeude/_id.vue';
import ReduktionWaermeerzeugerView from '@/views/auth/berechnungsgrundlagen/gebaeude/reduktion_waermeerzeuger/IndexView.vue';
import ReduktionWaermeerzeugerEditView from '@/views/auth/berechnungsgrundlagen/gebaeude/reduktion_waermeerzeuger/_id.vue';
import HoZuHuView from '@/views/auth/berechnungsgrundlagen/gebaeude/ho_zu_hu/IndexView.vue';
import StandardgemeindeView from '@/views/auth/berechnungsgrundlagen/produktion/standardgemeinde/IndexView.vue';
import StandardgemeindeEditView from '@/views/auth/berechnungsgrundlagen/produktion/standardgemeinde/_id.vue';
import TechnologieStromerzeugungView from '@/views/auth/berechnungsgrundlagen/produktion/technologie_stromerzeugung/IndexView.vue';
import TechnologieStromerzeugungEditView from '@/views/auth/berechnungsgrundlagen/produktion/technologie_stromerzeugung/_id.vue';
import ZuordnungTechnologieStromerzeugungView from '@/views/auth/berechnungsgrundlagen/produktion/zuordnung_technologie_stromerzeugung/IndexView.vue';
import ZuordnungTechnologieStromerzeugungEditView from '@/views/auth/berechnungsgrundlagen/produktion/zuordnung_technologie_stromerzeugung/_id.vue';
import KorrekturWerteStromerzeugungView from '@/views/auth/berechnungsgrundlagen/jahreswerte/korrektur_produktion/IndexView.vue';
import KorrekturWerteStromerzeugungEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/korrektur_produktion/_id.vue';
import ErgaenzungWerteStromerzeugungView from '@/views/auth/berechnungsgrundlagen/jahreswerte/ergaenzung_produktion/IndexView.vue';
import ErgaenzungWerteStromerzeugungEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/ergaenzung_produktion/_id.vue';
import EinwohnerzahlView from '@/views/auth/berechnungsgrundlagen/jahreswerte/einwohnerzahl/IndexView.vue';
import EinwohnerzahlEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/einwohnerzahl/_id.vue';
import ErdgasverbrauchView from '@/views/auth/berechnungsgrundlagen/jahreswerte/erdgasverbrauch/IndexView.vue';
import ErdgasverbrauchEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/erdgasverbrauch/_id.vue';
import ElektrizitaetsverbrauchView from '@/views/auth/berechnungsgrundlagen/jahreswerte/elektrizitaetsverbrauch/IndexView.vue';
import ElektrizitaetsverbrauchEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/elektrizitaetsverbrauch/_id.vue';
import EinspeisungBiogasView from '@/views/auth/berechnungsgrundlagen/jahreswerte/einspeisung_biogas/IndexView.vue';
import EinspeisungBiogasEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/einspeisung_biogas/_id.vue';
import LeitungsverlustFernwaermeView from '@/views/auth/berechnungsgrundlagen/jahreswerte/leitungsverlust_fernwaerme/IndexView.vue';
import LeitungsverlustFernwaermeEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/leitungsverlust_fernwaerme/_id.vue';
import StandardFermwaermemixView from '@/views/auth/berechnungsgrundlagen/jahreswerte/standard_fernwaermemix/IndexView.vue';
import StandardFermwaermemixEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/standard_fernwaermemix/_id.vue';
import HgtUndAtdView from '@/views/auth/berechnungsgrundlagen/jahreswerte/hgt_und_atd/IndexView.vue';
import HgtUndAtdEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/hgt_und_atd/_id.vue';
import CO2EmissionsfaktorView from '@/views/auth/berechnungsgrundlagen/jahreswerte/co2_emissionsfaktor/IndexView.vue';
import CO2EmissionsfaktorEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/co2_emissionsfaktor/_id.vue';
import KorrekturKalibrierungsfaktorView from '@/views/auth/berechnungsgrundlagen/jahreswerte/korrektur_kalibrierungsfaktor/IndexView.vue';
import KorrekturKalibrierungsfaktorEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/korrektur_kalibrierungsfaktor/_id.vue';
import JahresertragSolarstromanlageView from '@/views/auth/berechnungsgrundlagen/jahreswerte/jahresertrag_solarstromanlage/IndexView.vue';
import JahresertragSolarstromanlageEditView from '@/views/auth/berechnungsgrundlagen/jahreswerte/jahresertrag_solarstromanlage/_id.vue';

export default [
    {
        path: '/berechnungsgrundlagen/allgemein/gemeinde',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_allgemein],
        },
        children: [
            {
                path: '',
                name: 'bg_allg_gemeinde',
                component: GemeindenView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_allgemein],
                },
            },
            {
                name: 'bg_allg_gemeinde_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: GemeindeEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_allgemein],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/allgemein/nutzungsart',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_allgemein],
        },
        children: [
            {
                path: '',
                name: 'bg_allg_nutzungsart',
                component: NutzungsartView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_allgemein],
                },
            },
            {
                name: 'bg_allg_nutzungsart_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: NutzungsartEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_allgemein],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/nutzungsgrad_heizung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_nutzungsgrad_heizung',
                component: NutzungsgradWaermeerzeugerHeizungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_nutzungsgrad_heizung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: NutzungsgradWaermeerzeugerHeizungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/nutzungsgrad_warmwasser',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_nutzungsgrad_warmwasser',
                component: NutzungsgradWaermeerzeugerWarmwasserView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_nutzungsgrad_warmwasser_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: NutzungsgradWaermeerzeugerWarmwasserEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/zuordnung_energie_waermequelle',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_zuordnung_energie_waermequelle',
                component: ZuordnungEnergieWaermequelleView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_zuordnung_energie_waermequelle_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ZuordnungEnergieWaermequelleEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/zuordnung_gebaeudekategorie_zu_nutzungsart',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_gebaeudeklasse_nutzungsart',
                component: GebaeudeklasseNutzungsartView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_gebaeudeklasse_nutzungsart_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: GebaeudeklasseNutzungsartEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/kennzahl_nutzungsart',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_kennzahl_nutzungsart',
                component: KennzahlNutzungsartView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_kennzahl_nutzungsart_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: KennzahlNutzungsartEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/waermeerzeuger_heizung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_waermeerzeuger_heizung',
                component: WaermeerzeugerHeizungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_waermeerzeuger_heizung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: WaermeerzeugerHeizungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_heizung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_zuordnung_waermeerzeuger_heizung',
                component: ZuordnungWaermeerzeugerHeizungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_zuordnung_waermeerzeuger_heizung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ZuordnungWaermeerzeugerHeizungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/waermeerzeuger_warmwasser',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_waermeerzeuger_warmwasser',
                component: WaermeerzeugerWarmwasserView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_waermeerzeuger_warmwasser_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: WaermeerzeugerWarmwasserEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/zuordnung_waermeerzeuger_warmwasser',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_zuordnung_waermeerzeuger_warmwasser',
                component: ZuordnungWaermeerzeugerWarmwasserView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_zuordnung_waermeerzeuger_warmwasser_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ZuordnungWaermeerzeugerWarmwasserEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_heizung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_korrektur_waermeerzeuger_heizung',
                component: KorrekturWaermeerzeugerHeizungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_korrektur_waermeerzeuger_heizung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: KorrekturWaermeerzeugerHeizungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/korrektur_waermeerzeuger_warmwasser',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_korrektur_waermeerzeuger_warmwasser',
                component: KorrekturWaermeerzeugerWarmwasserView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_korrektur_waermeerzeuger_warmwasser_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: KorrekturWaermeerzeugerWarmwasserEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_heizung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_anteil_waermeerzeuger_heizung',
                component: AnteilWaermeerzeugerHeizungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_anteil_waermeerzeuger_heizung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: AnteilWaermeerzeugerHeizungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/anteil_waermeerzeuger_warmwasser',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_anteil_waermeerzeuger_warmwasser',
                component: AnteilWaermeerzeugerWarmwasserView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_anteil_waermeerzeuger_warmwasser_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: AnteilWaermeerzeugerWarmwasserEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/reduktion_angrenzende_gebaeude',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_reduktion_angrenzende_gebaeude',
                component: ReduktionAngrenzendeGebaeudeView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_reduktion_angrenzende_gebaeude_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ReduktionAngrenzendeGebaeudeEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/reduktion_waermeerzeuger',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_reduktion_waermeerzeuger',
                component: ReduktionWaermeerzeugerView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
            {
                name: 'bg_geb_reduktion_waermeerzeuger_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ReduktionWaermeerzeugerEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/gebaeude/ho_zu_hu',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_gebaeude],
        },
        children: [
            {
                path: '',
                name: 'bg_geb_ho_zu_hu',
                component: HoZuHuView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_gebaeude],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/produktion/standardgemeinde',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_produktion],
        },
        children: [
            {
                path: '',
                name: 'bg_prod_standardgemeinde',
                component: StandardgemeindeView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
            {
                name: 'bg_prod_standardgemeinde_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: StandardgemeindeEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/produktion/technologie_stromerzeugung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_produktion],
        },
        children: [
            {
                path: '',
                name: 'bg_prod_technologie_stromerzeugung',
                component: TechnologieStromerzeugungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
            {
                name: 'bg_prod_technologie_stromerzeugung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: TechnologieStromerzeugungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/produktion/zuordnung_technologie_stromerzeugung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_produktion],
        },
        children: [
            {
                path: '',
                name: 'bg_prod_zuordnung_technologie_stromerzeugung',
                component: ZuordnungTechnologieStromerzeugungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
            {
                name: 'bg_prod_zuordnung_technologie_stromerzeugung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ZuordnungTechnologieStromerzeugungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/korrektur_werte_stromerzeugung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_produktion],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_korrektur_werte_stromerzeugung',
                component: KorrekturWerteStromerzeugungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
            {
                name: 'bg_jw_korrektur_werte_stromerzeugung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: KorrekturWerteStromerzeugungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/ergaenzung_werte_stromerzeugung',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_produktion],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_ergaenzung_werte_stromerzeugung',
                component: ErgaenzungWerteStromerzeugungView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
            {
                name: 'bg_jw_ergaenzung_werte_stromerzeugung_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ErgaenzungWerteStromerzeugungEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_produktion],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/einwohnerzahl',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_einwohnerzahl',
                component: EinwohnerzahlView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_einwohnerzahl_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: EinwohnerzahlEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/erdgasverbrauch',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_erdgasverbrauch',
                component: ErdgasverbrauchView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_erdgasverbrauch_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ErdgasverbrauchEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/elektrizitaetsverbrauch',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_elektrizitaetsverbrauch',
                component: ElektrizitaetsverbrauchView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_elektrizitaetsverbrauch_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: ElektrizitaetsverbrauchEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/einspeisung_biogas',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_einspeisung_biogas',
                component: EinspeisungBiogasView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_einspeisung_biogas_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: EinspeisungBiogasEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/leitungsverlust_fernwaerme',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_leitungsverlust_fernwaerme',
                component: LeitungsverlustFernwaermeView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_leitungsverlust_fernwaerme_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: LeitungsverlustFernwaermeEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/standard_fernwaermemix',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_standard_fernwaermemix',
                component: StandardFermwaermemixView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_standard_fernwaermemix_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: StandardFermwaermemixEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/hgt_und_atd',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_hgt_und_atd',
                component: HgtUndAtdView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_hgt_und_atd_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: HgtUndAtdEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/co2_emissionsfaktor',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_co2_emissionsfaktor',
                component: CO2EmissionsfaktorView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_co2_emissionsfaktor_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: CO2EmissionsfaktorEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/korrektur_kalibrierungsfaktor',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_korrektur_kalibrierungsfaktor',
                component: KorrekturKalibrierungsfaktorView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_korrektur_kalibrierungsfaktor_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: KorrekturKalibrierungsfaktorEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
    {
        path: '/berechnungsgrundlagen/jahreswerte/jahresertrag_solarstromanlage',
        meta: {
            requiresAuth: true,
            roles: [ROLES.berechnungsgrundlagen_jahreswerte],
        },
        children: [
            {
                path: '',
                name: 'bg_jw_jahresertrag_solarstromanlage',
                component: JahresertragSolarstromanlageView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
            {
                name: 'bg_jw_jahresertrag_solarstromanlage_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: JahresertragSolarstromanlageEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.berechnungsgrundlagen_jahreswerte],
                },
            },
        ],
    },
];

